import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type BarPoint = {
  x: string
  y: number
  date: string
}

type GraphEntry = {
  points: BarPoint[]
  totalSum: number
}

interface ReferralsGraphCacheState {
  entries: Record<string, GraphEntry>

  makeKey: (opt: string) => string

  getPoints: (opt: string) => BarPoint[]
  getTotalSum: (opt: string) => number

  setGraph: (opt: string, points: BarPoint[], totalSum: number) => void

  clearOpt: (opt: string) => void
  clearAll: () => void
}

export const useReferralsGraphCacheStore = create<ReferralsGraphCacheState>()(
  persist(
    (set, get) => ({
      entries: {},

      makeKey: (opt: string) => `opt:${(opt ?? '').trim().toLowerCase()}`,

      getPoints: (opt: string) => {
        const key = get().makeKey(opt)
        return get().entries[key]?.points ?? []
      },

      getTotalSum: (opt: string) => {
        const key = get().makeKey(opt)
        return get().entries[key]?.totalSum ?? 0
      },

      setGraph: (opt: string, points: BarPoint[], totalSum: number) => {
        const key = get().makeKey(opt)
        set((state) => ({
          entries: {
            ...state.entries,
            [key]: { points, totalSum },
          },
        }))
      },

      clearOpt: (opt: string) => {
        const key = get().makeKey(opt)
        set((state) => {
          const next = { ...state.entries }
          // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
          delete next[key]
          return { entries: next }
        })
      },

      clearAll: () => set({ entries: {} }),
    }),
    {
      name: 'referrals-graph-cache-v1',
      partialize: (state) => ({ entries: state.entries }),
    }
  )
)
